import React from 'react'

let theme__ = [];
theme__[0] = {
    "--font-family": "",
    "--da-primary": "#3CCF4E",
    "--da-secondary": "#151515",
    "--progress-1": "#9C2AA0",
    "--progress-2": "#3CCF4E",
    "--progress-3": "#A8B400",
    "--progress-4": "#EB9700",
    "--progress-5": "#00B0CA"
};
theme__[1] = {
    "--font-family": "Gotham",
    "--da-primary": "#3D86C6",
    "--da-secondary": "#EA7926",
    "--progress-1": "#AF328A",
    "--progress-2": "#B0BC25",
    "--progress-3": "#FFCD00",
    "--progress-4": "#EA7926",
    "--progress-5": "#09BDDD"
}
theme__[2] = {
    "--font-family": "",
    "--da-primary": "#E60000",
    "--da-secondary": "#000000",
    "--progress-1": "#9C2AA0",
    "--progress-2": "#A8B400",
    "--progress-3": "#FECB00",
    "--progress-4": "#EB9700",
    "--progress-5": "#00B0CA"
};
theme__[3] = {
    "--font-family": "",
    "--da-primary": "#ED1C24",
    "--da-secondary": "#040000",
    "--progress-1": "#BD1A29",
    "--progress-2": "#ED1C24",
    "--progress-3": "#F04E30",
    "--progress-4": "#F37021",
    "--progress-5": "#FECB5E"
};
theme__[-1] = {
    "--font-family": "",
    "--da-primary": "",
    "--da-secondary": "",
    "--progress-1": "",
    "--progress-2": "",
    "--progress-3": "",
    "--progress-4": "",
    "--progress-5": ""
};


export default theme__